import { FieldArray } from './FieldArray';
import { FieldArrayControl } from './FieldArrayControl';
import { FieldArrayProvider } from './FieldArrayProvider';

export * from './context';

export type ReactHookFormArrayCompound = typeof FieldArrayProvider & {
  Map: typeof FieldArray;
  FieldControl: typeof FieldArrayControl;
};

export const HookFormFieldArray = Object.assign( FieldArrayProvider, {
  Map: FieldArray,
  FieldControl: FieldArrayControl,
} ) as ReactHookFormArrayCompound;
